// import { AuthenticatedTemplate } from "@azure/msal-react";
import { NavigationBar } from "../Header/NavigationBar";
import { FooterBar } from "../Footer/FooterBar";
import './PageLayout.css';

export const PageLayout = (props) => {
    return (
        <>
            <div className="page-container">
                <NavigationBar />
                <div className="page-main">
                    {props.children}
                    {/* <AuthenticatedTemplate>
                            <center>
                                How did we do?
                                <a
                                    href="https://forms.office.com/Pages/ResponsePage.aspx?id=v4j5cvGGr0GRqy180BHbR73pcsbpbxNJuZCMKN0lURpUMlRHSkc5U1NLUkxFNEtVN0dEOTFNQkdTWiQlQCN0PWcu"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    {' '}
                                    Share your experience!
                                </a>
                            </center>
                    </AuthenticatedTemplate> */}
                </div>
                <FooterBar />
            </div>
        </>
    );
}